import React from 'react';
import { Tooltip } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { PickupDropoffOption, Task } from '@bringg/types';
import type { TaskTooltipTranslations } from '../../../components/routes-planner/translations';
import './task-tooltip-title.scss';

type Props = {
	translations: TaskTooltipTranslations;
	dataToDisplay: Task;
	runColor: string;
	openOrderPage?: (id: number) => void;
};

const taskTypeIcons = {
	[PickupDropoffOption.PICKUP]: [{ iconName: BringgFontIcons.Pickup, iconTooltip: 'collect' }],
	[PickupDropoffOption.DROPOFF]: [{ iconName: BringgFontIcons.Dropoff, iconTooltip: 'deliver' }],
	[PickupDropoffOption.BOTH]: [
		{ iconName: BringgFontIcons.Pickup, iconTooltip: 'collect' },
		{ iconName: BringgFontIcons.Dropoff, iconTooltip: 'deliver' }
	]
};

const TaskTooltipTitle: React.FC<Props> = ({ translations, dataToDisplay, runColor, openOrderPage }: Props) => {
	const getTaskTypeIcon = () => {
		const iconsList = taskTypeIcons[dataToDisplay?.way_points[0]?.pickup_dropoff_option];
		return iconsList
			? iconsList.map(icon => (
					<div className="task-type-icon-container" key={icon.iconTooltip}>
						<Tooltip title={translations[icon.iconTooltip]}>
							<BringgIcon iconName={icon.iconName} className="task-type-icon" />
						</Tooltip>
					</div>
			  ))
			: null;
	};

	return (
		<div className="task-tooltip-body-title" style={{ '--color': runColor } as React.CSSProperties}>
			<span className="task-tooltip-body-title-subtitle">
				<Tooltip title={translations.openOrderPage}>
					<span
						data-test-id="tooltip-task-external-id"
						className="tooltip-task-external-id"
						onClick={() => openOrderPage?.(dataToDisplay.id)}
					>
						{dataToDisplay.external_id}
					</span>
				</Tooltip>
				<span className="tooltip-task-priority" data-test-id="tooltip-task-priority">
					{!dataToDisplay || dataToDisplay.priority === dataToDisplay.id
						? ' '
						: `(${dataToDisplay.priority})`}
				</span>
			</span>
			<span data-test-id="tooltip-task-type" className="tooltip-task-type">
				{getTaskTypeIcon()}
			</span>
		</div>
	);
};

export default TaskTooltipTitle;
